export default function ClipboardPlus(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13.5938 3.3125H22.4063C22.4063 3.3125 23.875 3.3125 23.875 4.78125V7.71875C23.875 7.71875 23.875 9.1875 22.4063 9.1875H13.5938C13.5938 9.1875 12.125 9.1875 12.125 7.71875V4.78125C12.125 4.78125 12.125 3.3125 13.5938 3.3125Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M23.875 6.25H26.8125C27.5916 6.25 28.3387 6.55949 28.8896 7.11037C29.4405 7.66126 29.75 8.40843 29.75 9.1875V29.75C29.75 30.5291 29.4405 31.2762 28.8896 31.8271C28.3387 32.378 27.5916 32.6875 26.8125 32.6875H9.1875C8.40843 32.6875 7.66126 32.378 7.11037 31.8271C6.55949 31.2762 6.25 30.5291 6.25 29.75V9.1875C6.25 8.40843 6.55949 7.66126 7.11037 7.11037C7.66126 6.55949 8.40843 6.25 9.1875 6.25H12.125"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.5938 20.9375H22.4062"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 25.3438V16.5312"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
